const BASE_DATA_ROUTE = [
  {
    path: 'base-data/country',
    name: 'BaseDataCountry',
    component: () => import('@/views/base-data/country'),
    meta: {
      title: '基础参数-国家',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'base-data/daily-exchange-rate',
    name: 'BaseDataDailyExchangeRate',
    component: () => import('@/views/base-data/daily-exchange-rate'),
    meta: {
      title: '基础参数-每日汇率',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'base-data/e-platform',
    name: 'BaseDataEPlatform',
    component: () => import('@/views/base-data/e-platform'),
    meta: {
      title: '基础参数-电商平台',
      icon: '',
      keepAlive: true,
    },
  },
]
export default BASE_DATA_ROUTE
